var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b82121;opacity:0.5;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,0A24,24,0,0,1,37.958,43.526,23.666,23.666,0,0,1,24,48,24,24,0,0,1,24,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 12.996)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.209,275.48l-1.28-1.28-6.523,6.527-.627-3.309L0,277.758l1.066,5.612,5.6,1.053L7,282.648,3.67,282.02Z",
    transform: "translate(0 -262.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M283.365,6.564,282.3.953,276.7-.1l-.335,1.775L279.7,2.3l-6.6,6.6,1.28,1.276L280.959,3.6l.627,3.309Z",
    transform: "translate(-261.365 0.1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.0821363d.svg";
export { ForwardRef as ReactComponent };